export default "__VITE_ASSET__ClxfkeOU__"